import { AppUpdateNotice } from "@features/appUpdateNotice";

import { BrandThemeProvider, ApplyBrandTheme } from "@shared/lib/brandTheme";

import { StoreProvider } from "../storeProvider";
import { ToastProvider } from "../toastProvider";
import { LanguageInitializer } from "../languageInitializer";
import { AppInitializers } from "../appInitializers";
import { AuthInitializer } from "../authInitializer";

export const MainProviders = ({ children }) => {
  return (
    <BrandThemeProvider>
      <ApplyBrandTheme />
      <StoreProvider>
        <LanguageInitializer>
          <AuthInitializer>
            <AppInitializers />
            {children}
          </AuthInitializer>
          <ToastProvider />
          <AppUpdateNotice />
        </LanguageInitializer>
      </StoreProvider>
    </BrandThemeProvider>
  );
};
